import { v4 as uuidv4 } from "uuid";
import { generateStaticQuestionId } from "../../../../../utils/goalsUtils";

export const feedbackIdeasComments = {
    "blockId": uuidv4(),
    "goalId": "comments",
    "isTemplate": true,
    "questions": [
        {
            "staticQuestionId": generateStaticQuestionId("Please share a couple feedforward ideas or advice for what can specifically be done by this leader to improve (i.e., offer some positive suggestions for the future)."),
            "question": "Please share a couple feedforward ideas or advice for what can specifically be done by this leader to improve (i.e., offer some positive suggestions for the future).",
            "HTMLQuestion": "<p>Please share a couple feedforward ideas or advice for what can specifically be done by this leader to improve (i.e., offer some positive suggestions for the future).</p>",
            "options": [],
            "isSelected": true,
            "type": "Text Entry",
            "qid": uuidv4(),
            "questionLabel": ""
        }
    ],
    "isSelected": true,
    "isTextEntryOnly": true,
    "type": "textEntry",
    "dimension": "Comments"
}